import {useEffect} from "react";
import {useSetState} from "ahooks";
import {Button, Form, message, Spin} from "antd";
import {getUser} from "shj-utils";
import {SGeneralForms, STitle} from "shj-components";

import {getCustomerSource} from "@/services/customerServices.ts";
import {getChannelMarkListByChannelId} from "@/services/channelManagement.ts";
import {getBusinessLines} from "@/services/getUsers.ts";
import {getEnums, httpOrgList} from "@/services/homeService.ts";
import {getAnchorFn, getUserIdentityFn} from "@/pages/clueManage/utils.tsx";
import {getDispatchMnrList} from "@/services/saleOpServices.ts";
import styles from './index.module.less'
import {phoneRegExp} from "@/utils/regular.tsx";
import {addClue} from "@/services/callCenter";

export const AddForm = () => {
  const userInfo = getUser()
  const [form] = Form.useForm()
  const [state, setState] = useSetState<any>({
    loading: false
  })

  useEffect(() => {
    getOptions()
    onCancel()
  }, []);

  const getOptions = () => {
    setState({loading: true})
    Promise.allSettled([
      getBusinessLines(),
      getEnums("dispatcher", "com.shj.saas.plus.clue.enums.ArmyAffiliation"),
      httpOrgList(),
      getUserIdentityFn(['ykf']),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.HouseNatureEnum'),
    ]).then((resList: any) => {
      const map = {
        brandCodeList: resList?.[0]?.value instanceof Array ? resList?.[0]?.value : [],
        armyAffiliationList: resList?.[1]?.value instanceof Array ? resList?.[1]?.value : [],
        companyList: resList?.[2]?.value instanceof Array ? resList?.[2]?.value : [],
        ykfList: resList?.[3]?.value instanceof Array ? resList?.[3]?.value : [],
        bizOpPropertyTypeList: resList?.[4]?.value instanceof Array ? resList?.[4]?.value : [],
      }
      setState(map)
    }).finally(() => {
      setState({loading: false})
    })
  }

  // 根据客户来源的id更新
  const fetchSignData = (id: any) => {
    setState({signData: []})
    const channelId = id[id.length - 1] || '';
    if (!channelId) return;
    setState({loading: true})
    getChannelMarkListByChannelId(channelId).then((res: any) => {
      const list = res || []
      if (!list.length) message.warning('当前来源暂无渠道标记');
      setState({signData: [...list]});
    }).finally(() => setState({loading: false}));
  };

  const handleCity = (data) => {
    const obj = {}
    return data.reduce((res, item) => {
      if(!obj[item.cityCode]) {
        res.push(item)
      }
      obj[item.cityCode] = true
      return res;
    }, [])
  }

  const onCompanyCodeChange = (val: string) => {
    setState({cityArea: [], anchor: [], liveOperation: [], advert: [], sourceChannelList: []});
    form.setFieldValue('channelId', null);
    // 报名城市
    getDispatchMnrList({storeId: val})
        .then((res: any) => {
          setState({cityArea: handleCity(res || [])});
        })
        .catch(() => {
          setState({cityArea: []});
        });
    if (val) {
      setState({loading: true})
      try {
        getAnchorFn('ANCHOR', val).then((res) => {
          setState({anchor: res || []})
        })
        getAnchorFn('LIVE_OPERATION', val).then((res) => {
          setState({liveOperation: res || []})
        })
        getAnchorFn('ADVERT', val).then((res) => {
          setState({advert: res || []})
        })
        getCustomerSource({state: 'CHECKED', orgId: val}).then(res => {
          setState({sourceChannelList: res || []})
        })
      } finally {
        setState({loading: false})
      }
    }
  };

  const onSubmit = () => {
    form.validateFields().then((values) => {
      const data: any = { ...values, clueSource: 'MANUAL' };
      if (data.channelId) {
        //修改客户来源正确值
        data.channelId = data.channelId[data.channelId.length - 1];
      }
      setState({loading: true})
      addClue({ ...data, clueSource: 'CALL_PAGE' })
          .then((res: any) => {
            message.success(res.message || '操作成功');
            onCancel();
          })
          .finally(() => {
            setState({loading: false})
          });
    })
  }

  const onCancel = () => {
    form.resetFields();
    form.setFieldValue('orgId', userInfo.companyId);
    onCompanyCodeChange(userInfo.companyId)
  }

  return <div className={styles.formBox}>
    <STitle title={'线索新增'} titleMode={'edit'}/>
    <Spin spinning={state.loading} style={{height: '100%'}}>
      <div className={styles.formWrap}>
        <SGeneralForms
            layout={'vertical'}
            formConfig={{form}}
            configs={[{
              formItem: [
                {
                  spanCol: 12, label: '客户来源', name: 'channelId', type: 'cascader',
                  required: true,
                  rules: [{required: true, message: '不能为空'}],
                  comConfig: {
                    expandTrigger: 'hover',
                    options: state.sourceChannelList,
                    showSearch: true,
                    onChange: (v) => fetchSignData(v),
                    notFoundContent: '请选择公司或无匹配数据',
                  }
                },
                {
                  spanCol: 12, label: '渠道标记', name: 'channelTag', type: 'select',
                  comConfig: {
                    options: state.signData,
                    fieldNames: {label: 'markName', value: 'id'}
                  }
                },
                {
                  spanCol: 12, label: '品牌', name: 'channelBrandId',
                  required: true,
                  rules: [{required: true, message: '不能为空'}],
                  type: 'select',
                  comConfig: {
                    options: state.brandCodeList,
                    fieldNames: {label: 'brandName', value: 'id'}
                  }
                },
                {
                  spanCol: 12, label: '总分归属', name: 'armyAffiliation',
                  type: 'select',
                  required: true,
                  rules: [{required: true, message: '不能为空'}],
                  comConfig: {
                    options: state.armyAffiliationList,
                    fieldNames: {label: 'description', value: 'key'}
                  }
                },
                {
                  spanCol: 12, label: '客户姓名', name: 'name',
                  required: true,
                  rules: [{required: true, message: '不能为空'}],
                  comConfig: {
                    maxLength: 50,
                    showCount: true,
                    placeholder: '请输入客户名称',
                    onBlur: e => {
                      const value = e.target.value
                      // 去除所有空格
                      if (value) {
                        const newValue = value.replace(/\s/g, '')
                        form.setFieldValue('name', newValue)
                      }
                    },
                  },
                },
                {
                  spanCol: 12, label: '联系电话', name: 'phone',
                  required: true,
                  rules: [{required: true, message: '不能为空'}, {message: '请输入正确的电话号码', pattern: phoneRegExp}],
                },
                {
                  spanCol: 12, label: '云客服', name: 'callUserId',
                  type: 'select',
                  required: true,
                  rules: [{required: true, message: '不能为空'}],
                  comConfig: {
                    options: state.ykfList,
                    fieldNames: {label: 'userName', value: 'ucenterUserId'},
                    onChange: (e, op) => {
                      form.setFieldValue('callUserName', op?.userName)
                      form.setFieldValue('callDeptId', op?.orgId)
                      form.setFieldValue('callOrgId', op?.companyId)
                    }
                  },
                },
                {label: '云客服', name: 'callUserName', hidden: true},
                {label: '云客服', name: 'callDeptId', hidden: true},
                {label: '云客服', name: 'callOrgId', hidden: true},
                {
                  spanCol: 12, label: '房屋属性', name: 'houseNatureCode',
                  type: 'select',
                  required: true,
                  rules: [{required: true, message: '不能为空'}],
                  comConfig: {
                    options: state.bizOpPropertyTypeList,
                    fieldNames: {label: 'description', value: 'key'}
                  }
                },
                {
                  spanCol: 12, label: '是否派单', name: 'isDispatch',
                  type: 'select',
                  required: true,
                  rules: [{required: true, message: '不能为空'}],
                  comConfig: {
                    options: [{label: '是', value: true}, {label: '否', value: false}],
                  }
                },
                {
                  spanCol: 12, label: '分公司', name: 'orgId',
                  type: 'select',
                  required: true,
                  rules: [{required: true, message: '不能为空'}],
                  comConfig: {
                    options: state.companyList,
                    fieldNames: {label: 'name', value: 'id'},
                    onChange: onCompanyCodeChange
                  }
                },
                {
                  spanCol: 12, label: '报名城市', name: 'cityAreaCode',
                  type: 'select',
                  required: true,
                  rules: [{required: true, message: '不能为空'}],
                  comConfig: {
                    options: state.cityArea,
                    fieldNames: {label: 'regionName', value: 'cityCode'}
                  }
                },
                {
                  spanCol: 12, label: '主播', name: 'anchorEmployeeId',
                  type: 'select',
                  comConfig: {
                    options: state.anchor,
                    fieldNames: {label: 'userName', value: 'ucenterUserId'},
                    onChange: (e, op) => form.setFieldValue('anchorName', op?.userName),
                  }
                },
                {spanCol: 12, label: '主播', name: 'anchorName', hidden: true},
                {
                  spanCol: 12, label: '直播运营', name: 'liveOperationEmployeeId',
                  type: 'select',
                  comConfig: {
                    options: state.liveOperation,
                    fieldNames: {label: 'userName', value: 'ucenterUserId'},
                    onChange: (e, op) => form.setFieldValue('liveOperationName', op?.userName),
                  }
                },
                {spanCol: 12, label: '直播运营', name: 'liveOperationName', hidden: true},
                {
                  spanCol: 12, label: '优化师', name: 'advertEmployeeId',
                  type: 'select',
                  comConfig: {
                    options: state.advert,
                    fieldNames: {label: 'userName', value: 'ucenterUserId'},
                    onChange: (e, op) => form.setFieldValue('advertName', op?.userName),
                  }
                },
                {spanCol: 12, label: '优化师', name: 'advertName', hidden: true},
                {
                  spanCol: 12,
                  label: '建筑面积',
                  name: 'constructionArea',
                  type: 'inputNumber',
                  required: true,
                  rules: [{required: true, message: '不能为空'}],
                  comConfig: {
                    precision: 2,
                    min: 0.01,
                    max: 999999999.99,
                  },
                },
                {
                  spanCol: 24,
                  label: '备注',
                  name: 'remark',
                  type: 'textarea',
                  comConfig: {maxLength: 700, showCount: true}
                },
              ]
            }]}
        />
      </div>
    </Spin>
    <div className={styles.userFormSaveBtn}>
      <Button disabled={state.loading} style={{marginRight: 10}} onClick={onCancel}>取消</Button>
      <Button disabled={state.loading} type={'primary'} onClick={onSubmit}>保存</Button>
    </div>
  </div>
}